import { Pipe, PipeTransform } from '@angular/core';
import { groupDigits } from '../helpers/number.helper';

/**
 * Chains after the amount pipes — `{{ x | amount: currency | grouped }}` — to
 * make large figures readable. Display only: it never changes precision, and
 * the '-' / '' placeholders those pipes emit pass through untouched.
 */
@Pipe({ name: 'grouped', standalone: true })
export class GroupDigitsPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    return groupDigits(value);
  }
}
